import { BookOpen } from "@gravity-ui/icons";
import { Avatar } from "@gravity-ui/uikit";
import { Link as RouterLink } from "react-router-dom";
import { POIZON_API_DOCS_LINK } from "src/constants/links";

import css from "./DocsBlock.module.scss";

export const DocsBlock = () => {
  return (
    <div className={css.button}>
      <RouterLink to={POIZON_API_DOCS_LINK}>
        <Avatar size="l" className={css.button} view="filled" icon={BookOpen} />
      </RouterLink>
    </div>
  );
};
